module.exports = __webpack_public_path__ + "static/SandeepRangroo-fd09094e1ee532bf2a8ae6a54379b2b2.jpg";